export const LOAD_BANK = 'LOAD_BANK'
export const ADD_BANK = 'ADD_BANK'


